<template>
  <div class="figmacn" id="figmacn">
    <span id="alert">
      🚀
      <strong>1.0 版本已发布，请重新下载更新（商店安装自动更新）</strong>
      <i>👏</i> 加入 Figma 微信讨论群，添加微信：yancy_min - 2020.06.17
    </span>
    <div class="nav" id="nav">
      <img src="../assets/figmaCN.svg" />
    </div>
    <div class="hero">
      <div class="left">
        <h1>FigmaCN</h1>
        <p>中文 Figma 插件，设计师人工翻译校验</p>
        <a
          class="chrome-store"
          href="https://chrome.google.com/webstore/detail/japkpjkpfdakpkbcehooampdjfgefndj"
        >
          <!-- <img src="../assets/chrome.png" alt /> -->
        </a>
        <a class="crx" href="/figmaCN.zip" download>获取离线安装包</a>
      </div>
      <img class="hero-image" src="../assets/hero-image.jpg" alt />
    </div>
    <div class="crx-info">
      <h2>如何离线安装</h2>
      <span>请按照以下步骤将扩展程序添加到你的 Google Chrome 浏览器中。</span>
      <a class="crx" href="/figmaCN.zip" download>获取离线安装包</a>
      <div class="info">
        <p>地址栏输入 chrome://extensions 进入扩展程序管理界面；</p>
        <p>在扩展程序界面开启右上方的开发者模式；</p>
        <p>解压下载好的 .zip 文件并记下解压后的文件路径；</p>
        <p>最后点击左上角的「加载已解压的扩展程序」按钮，然后选择解压后的文件夹加载插件。</p>
      </div>
    </div>
    <a href="/" target="_blank" class="card">
      <div class="dr-night fgc">
        <div class="dr-left">
          <img src="../assets/logo.svg" class="card-logo" alt />
          <div class="dr-logo-text">
            <h3></h3>
            <p></p>
          </div>
        </div>
        <img class="dr-screen" src="../assets/card-cover-1.png" alt />
      </div>
    </a>
    <a
      href="https://www.figma.com/community/plugin/851126455550003999/Chinese-Font-Picker"
      target="_blank"
      class="card"
    >
      <div class="dr-night">
        <div class="dr-left">
          <img src="../assets/card-logo-2.png" alt />
          <div class="dr-logo-text">
            <h3>Chinese Font Picker</h3>
            <p>Figma 中文字体选择器</p>
          </div>
        </div>
        <img class="dr-screen" src="../assets/card-cover-2.png" alt />
      </div>
    </a>
    <a href="https://cn.figma.cool/words" target="_blank" class="card" id="words">
      <div class="dr-night fgc">
        <div class="dr-left">
          <img src="../assets/card-logo-3.svg" class="card-logo" alt />
          <div class="dr-logo-text">
            <h3>Figma 界面中英词条集</h3>
            <p></p>
          </div>
        </div>
        <img class="dr-screen" src="../assets/card-cover-3.png" alt />
      </div>
    </a>
    <footer>
      <a
        href="https://www.producthunt.com/posts/figmacn?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-figmacn"
        target="_blank"
        class="pht"
      >
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=179926&theme=light"
          alt="FigmaCN - 中文 Figma Chrome 插件，设计师人工翻译校验 | Product Hunt Embed"
          style="width: 185px; height: 40px;"
          width="185px"
          height="40px"
        />
      </a>
      <p>
        <a href="mailto:me@yancymin.design" target="_blank">me@yancymin.design</a>
        | Designed & Developed by
        <a href="https://yancymin.design" target="_blank">Yancy Min</a>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'figmacn'
}
</script>

<style lang="scss" scoped>
$gray-1: #f6f6f8;
$gray-2: #3f4372;
$gray-3: #e5e5e5;

.card {
  &:nth-of-type(2) {
    .dr-screen {
      right: 62px !important;
      bottom: -25px !important;
    }
  }
}

#words {
  .card-logo {
    width: 48px !important;
  }
  .dr-logo-text {
    h3 {
      margin-bottom: 0 !important;
    }
  }

  .dr-screen {
    box-shadow: none;
    height: 240px;
    bottom: -36px;
    right: 59px;
    border: 1px solid #eee;
  }
}

.fgc {
  overflow: hidden;

  .dr-screen {
    height: 100%;
    max-width: 100% !important;
    bottom: -30px;
    top: unset !important;
    box-shadow: 0px 14px 25px rgba(62, 67, 115, 0.1);
  }

  .card-logo {
    width: 120px !important;
  }
}

@mixin font($size, $weight, $lineHeight) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: $gray-2;
  font-weight: $weight;
  font-size: #{$size}px;
  line-height: #{$lineHeight}px;
  @content;
}

#alert {
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  position: fixed;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  color: #64698f;
  line-height: 17px;
  padding: 20px 20px;
  font-size: 14px;
  background: hsla(0, 0%, 100%, 0.85);
  box-shadow: 0px 20px 100px rgba(62, 67, 115, 0.15);
  backdrop-filter: blur(20px);
  animation: alertShow 4s ease forwards;

  i {
    margin-right: 8px;
  }

  @keyframes alertShow {
    0%,
    80% {
      width: 100vw;
      height: 100vh;
    }
    100% {
      width: 100vw;
      height: 80px;
    }
  }

  strong {
    font-weight: 800;
    margin: 0 8px 0 6px;
  }
}

.figmacn {
  width: 100%;
  padding: 160px 20px 20px 20px;
  display: flex;
  align-items: center;
  flex-direction: column;

  .hero {
    display: flex;
    justify-content: space-between;
    max-width: 1640px;
    width: 100%;
    height: 517px;
    background: #ffffff;
    box-shadow: 0px 1px 3px rgba(62, 67, 115, 0.3);
    border-radius: 12px;
    overflow: hidden;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-left: 120px;

      h1 {
        margin-bottom: 24px;
        @include font(56, 700, 56);
      }

      p {
        margin-bottom: 80px;
        @include font(20, 400, 20);
      }

      .chrome-store {
        position: relative;
        width: 280px;
        height: 90px;
        box-shadow: 0 0 0 1px $gray-3;
        margin-bottom: 20px;
        background-color: white;
        background-image: url('../assets/chrome.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 80% auto;
        transition: all 0.3s ease;

        /* &::before {
          display: none;
          position: absolute;
          top: -30px;
          left: 12%;
          content: '上架审核中，目前请下载离线安装包';
          display: inline-block;
          padding: 6px;
          background-color: #333;
          border-radius: 2px;
          font-size: 12px;
          color: $gray-1;
          opacity: 0;
          transition: all 0.25s ease;
          transform: translateY(2px);
        } */

        &:hover {
          box-shadow: 0px 8px 16px rgba(62, 67, 115, 0.16);

          /* &::before {
            opacity: 1;
            transform: translateY(0);
          } */
        }

        img {
          width: 223px;
          pointer-events: none;
        }
      }
    }

    .hero-image {
      align-self: flex-end;
      width: 700px;
      margin-right: 40px;
      pointer-events: none;
    }
  }
  .crx {
    position: relative;
    display: inline-block;
    transition: all 0.25s ease;
    @include font(14, 400, 14);

    &::after {
      position: absolute;
      right: -9px;
      top: 2px;
      content: '';
      width: 6px;
      height: 11px;
      background: url('../assets/arrow.svg') no-repeat;
      background-size: cover;
    }

    &:hover {
      text-decoration: underline;
      color: #458aff;
    }
  }

  .crx-info {
    display: flex;
    flex-direction: column;
    max-width: 680px;
    width: 100%;
    margin-top: 140px;
    padding-top: 60px;
    border-top: 1px solid $gray-3;
    text-align: left;

    h2 {
      @include font(24, 800, 24);
      margin-bottom: 20px;
    }
    span {
      margin-bottom: 32px;
      // margin-left: -20px;
      @include font(14, 600, 20);
    }

    a {
      &::after {
        right: unset;
        margin-left: 3px;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 100px;
      margin-bottom: 100px;

      p {
        max-width: 400px;
        position: relative;
        margin-bottom: 40px;
        margin-left: 38px;
        display: inline-block;
        width: 100%;
        margin-bottom: 28px;
        @include font(14, 400, 22);

        &:nth-of-type(1) {
          &::before {
            content: '1';
          }
        }
        &:nth-of-type(2) {
          &::before {
            content: '2';
          }
        }
        &:nth-of-type(3) {
          &::before {
            content: '3';
          }
        }
        &:nth-of-type(4) {
          line-height: 22px;
          &::before {
            content: '4';
          }
        }

        &::before {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          background-color: #f2f2f2;
          border-radius: 24px;
          margin-right: 16px;
          position: absolute;
          top: -1px;
          left: -38px;
        }
      }
    }
  }
  .dr-night {
    max-width: 680px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 90px 60px;
    background: #ffffff;
    transition: all 0.25s ease;

    .dr-left {
      display: flex;
      align-items: center;
      img {
        width: 48px;
        margin-right: 20px;
      }
      .dr-logo-text {
        text-align: left;

        h3 {
          @include font(24, 600, 24);
          margin-bottom: 10px;
        }
        p {
          @include font(14, 400, 14);
        }
      }
    }

    .dr-screen {
      /* max-width: 175px; */
      position: absolute;
      right: 32px;
      top: 0;
      pointer-events: none;
      height: 100%;
      max-width: 100% !important;
      bottom: -30px;
      top: unset !important;
    }
  }

  .card {
    max-width: 680px;
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;
    box-shadow: 0px 1px 3px rgba(62, 67, 115, 0.3);
    border-radius: 12px;

    &:hover {
      .dr-night {
        background-color: #f5f5f5;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
      }
    }
  }

  footer {
    margin-top: 80px;

    p {
      a {
        &:last-child {
          text-decoration: underline;
        }
      }
    }

    @include font(12, 400, 12) {
      color: hsl(0, 0%, 60%);
    }
    .pht {
      display: inline-block;
      margin-bottom: 20px;
    }

    a {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  #figmacn {
    .hero {
      height: auto;

      h1 {
        @include font(48, 700, 48);
      }

      p {
        margin-bottom: 50px;
        @include font(16, 400, 16);
      }
    }
    .left {
      margin-left: 7%;
    }
    .hero-image {
      margin-right: 0;
      width: 56%;
    }
  }
}
@media screen and (max-width: 1100px) {
  #figmacn {
    h1 {
      font-size: 40px;
      margin-bottom: 10px;
    }
    .hero .left p {
      margin-bottom: 30px;
    }
  }
}
@media screen and (max-width: 1000px) {
  .fgc {
    justify-content: center !important;
  }
  #figmacn {
    .nav {
      height: 60px;

      img {
        height: 34px;
      }
    }
    .left {
      margin: 0;
    }
    h1 {
      font-size: 48px;
      margin-bottom: 16px;
    }
    .hero .left p {
      margin-bottom: 60px;
    }
    .hero {
      padding: 80px 0 0 0;
      flex-direction: column;
      align-items: center;
    }
    .hero-image {
      width: 100%;
      margin-top: 80px;
      align-self: unset;
    }

    .crx-info {
      margin-top: 80px;
    }

    .info {
      margin-top: 60px;
      margin-bottom: 40px;
      padding: 0 20px;

      p {
        position: relative;
        // margin-bottom: 40px;
        line-height: 22px;
        margin-left: 38px;

        &::before {
          position: absolute;
          top: 0;
          left: -38px;
        }
      }
    }

    .dr-night {
      padding: 50px 20px;

      .dr-screen {
        display: none;
      }
    }

    footer {
      margin-top: 40px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 500px) {
  #alert {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    z-index: 9999;
    height: 80px;
    padding: 40px 20px;
    font-size: 12px;
    animation: alertShow2 4s ease forwards;

    strong {
      margin: 4px 8px 0 0;
    }

    @keyframes alertShow2 {
      0%,
      80% {
        width: 100vw;
        height: 100vh;
      }
      100% {
        width: 100vw;
        height: 100px;
      }
    }
  }
  #figmacn {
    .hero {
      background-color: white;
    }
    .chrome-store {
      &::before {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}

.nav {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  width: 100vw;
  height: 90px;
  position: fixed;
  background-color: white;
  box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.1);
  top: 0;
  transform: translateY(-140%);
  transition: all 0.3s ease;

  img {
    height: 40px;
  }
}
.navShow {
  transform: translateY(0) !important;
}
</style>
